module.exports = __webpack_public_path__ + "img/school.5e52a278.png";